import { action, withoutPayload, withPayload } from '../../../utility/redux';
import { ItemId, Scenes } from '../../../types/items';
import { ItemList, ListParams } from '../../../types/main';

export const initScenesRequest = action(
  'INIT_SCENES_REQUEST',
  withoutPayload,
);
export const initScenesSuccess = action(
  'INIT_SCENES_SUCCESS',
  withPayload<Scenes>(),
);
export const initScenesFail = action(
  'INIT_SCENES_FAIL',
  withoutPayload,
);

export const getScenesListRequest = action(
  'GET_SCENES_LIST_REQUEST',
  withPayload<ListParams>(),
);
export const getScenesListSuccess = action(
  'GET_SCENES_LIST_SUCCESS',
  withPayload<ItemList<Scenes>>(),
);
export const getScenesListFail = action(
  'GET_SCENES_LIST_FAIL',
  withoutPayload,
);

export const getScenesRequest = action(
  'GET_SCENES_REQUEST',
  withPayload<ItemId>(),
);
export const getScenesSuccess = action(
  'GET_SCENES_SUCCESS',
  withPayload<Scenes>(),
);
export const getScenesFail = action(
  'GET_SCENES_FAIL',
  withoutPayload,
);

export const createScenesRequest = action(
  'CREATE_SCENES_REQUEST',
  withPayload<Scenes>(),
);

export const duplicateScenesRequest = action(
  'DUPLICATE_SCENES_REQUEST',
  withPayload<Scenes>(),
);
export const createScenesSuccess = action(
  'CREATE_SCENES_SUCCESS',
  withPayload<Scenes>(),
);
export const createScenesFail = action(
  'CREATE_SCENES_FAIL',
  withoutPayload,
);

export const saveScenesRequest = action(
  'SAVE_SCENES_REQUEST',
  withPayload<Scenes & { notifyLastScriptAutoSave?: boolean }>(),
);
export const saveScenesSuccess = action(
  'SAVE_SCENES_SUCCESS',
  withPayload<Scenes>(),
);
export const saveScenesFail = action(
  'SAVE_SCENES_FAIL',
  withoutPayload,
);

export const deleteScenesRequest = action(
  'DELETE_SCENES_REQUEST',
  withPayload<ItemId>(),
);
export const deleteScenesSuccess = action(
  'DELETE_SCENES_SUCCESS',
  withPayload<ItemId>(),
);
export const deleteScenesFail = action(
  'DELETE_SCENES_FAIL',
  withoutPayload,
);

export const resetCurrentScenes = action(
  'RESET_CURRENT_SCENES',
  withoutPayload,
);

export const setScenesDirty = action(
  'SET_DIRTY_SCENES',
  withPayload<boolean>(),
);

export const updateScenesList = action(
  'UPDATE_SCENES_LIST',
  withPayload<Scenes[]>(),
);

export const updateScenesListRequest = action(
  'UPDATE_SCENES_LIST_REQUEST',
  withPayload<Scenes[]>(),
);

export const setCurrentSceneId = action(
  'SET_CURRENT_SCENE_ID',
  withPayload<number>(),
);

export const clearSceneList = action(
  'CLEAR_SCENE_LIST',
  withoutPayload,
);

export const setRefreshScenesList = action(
  'SET_REFRESH_SCENES_LIST',
  withPayload<boolean>(),
);

export const getScenesListRefreshRequest = action(
  'GET_SCENES_LIST_REFRESH_REQUEST',
  withPayload<ListParams>(),
);
export const getScenesListRefreshSuccess = action(
  'GET_SCENES_LIST_REFRESH_SUCCESS',
  withPayload<ItemList<Scenes>>(),
);

export const setEditingScript = action(
  'SET_EDITING_SCRIPT',
  withPayload<boolean>(),
);
export const setSavingScript = action(
  'SET_SAVING_SCRIPT',
  withPayload<boolean>(),
);
export const setSavedScript = action(
  'SET_SAVED_SCRIPT',
  withPayload<boolean>(),
);
